'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIPopoverFooter;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PopoverContext = require('../context/PopoverContext');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var handlePadding = function handlePadding(hasStructuredFooter, popoverUse) {
  if (popoverUse === 'longform') return '0 ' + _sizes.TOOLTIP_LONGFORM_PADDING + ' ' + _sizes.POPOVER_PADDING_Y;

  if (popoverUse === 'shepherd') {
    var paddingTop = hasStructuredFooter ? (0, _Styles.toPx)(parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.SHEPHERD_PADDING_Y, 10)) : '0px';
    var paddingBottom = hasStructuredFooter ? _sizes.POPOVER_PADDING_Y : _sizes.SHEPHERD_PADDING_Y;
    return paddingTop + ' ' + _sizes.POPOVER_PADDING_X + ' ' + paddingBottom + ' ' + _sizes.POPOVER_PADDING_X;
  }

  return _sizes.POPOVER_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X;
};

var Footer = _styledComponents2.default.footer.withConfig({
  displayName: 'UIPopoverFooter__Footer'
})(['background:inherit;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0;padding:', ';text-align:', ';', ';'], function (_ref) {
  var flush = _ref.flush,
      hasStructuredFooter = _ref.hasStructuredFooter,
      popoverUse = _ref.popoverUse;
  return flush ? '0' : handlePadding(hasStructuredFooter, popoverUse);
}, function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var hasStep = _ref3.hasStep;
  return hasStep ? (0, _styledComponents.css)(['display:flex;justify-content:space-between;align-items:center;']) : null;
});

function UIPopoverFooter(_ref4) {
  var className = _ref4.className,
      rest = _objectWithoutProperties(_ref4, ['className']);

  return _react2.default.createElement(Footer, _extends({}, rest, {
    className: (0, _classnames2.default)(className, 'uiPopoverFooter private-popover__footer'),
    popoverUse: (0, _react.useContext)(_PopoverContext.PopoverContext).use
  }));
}

UIPopoverFooter.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'right']).isRequired,
  children: _propTypes2.default.node,
  flush: _propTypes2.default.bool,
  hasStep: _propTypes2.default.bool,
  hasStructuredFooter: _propTypes2.default.bool
};

UIPopoverFooter.defaultProps = {
  align: 'left',
  hasStructuredFooter: false,
  hasStep: false
};

UIPopoverFooter.displayName = 'UIPopoverFooter';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIPopoverFooter.js
// module id = 471
// module chunks = 177